//External Links part

import axios from 'axios';
import config from './config';

export class ExternalLinksAPI {
    static async getExternalLinks() {
        return new Promise(function (resolve, reject) {
            axios
                .get(config.apiUrl + '/externalsystemlinks/')
                .then((response) => {
                    let externalSystemLinks = [];
                    if (response?.data?.__data) {
                        response.data?.__data.forEach((exSysLink) => {
                            try {
                                if (exSysLink.param1.split('|').indexOf('Agyle') >= 0) {
                                    externalSystemLinks.push(exSysLink);
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        });
                    }
                    resolve(externalSystemLinks);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static async getICELoginXml(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(config.apiUrl + '/externalsystemlinks/getICELoginXml', data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    let result =
                        "External System Links service error 'getICELoginXml()' " + error.status + '\n' + 'Response_Error_' + error.status;
                    reject([result, error.status]);
                });
        });
    }

    static async getVitalPacAuthenticationCode(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(config.apiUrl + '/externalsystemlinks/getVitalPacAuthenticationCode', data)
                .then((authCode) => {
                    resolve(authCode);
                })
                .catch((error) => {
                    console.error(error);
                    let result =
                        "External System Links service error 'getVitalPacAuthenticationCode()' " +
                        error.status +
                        '\n' +
                        'Response_Error_' +
                        error.status;
                    reject([result, error.status]);
                });
        });
    }

    static async getSAMLResponse(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(config.apiUrl + '/externalsystemlinks/getSAMLResponse', data)
                .then((samlResponse) => {
                    resolve(samlResponse);
                })
                .catch((error) => {
                    let result =
                        "External System Links service error 'getSAMLResponse()' " + error.status + '\n' + 'Response_Error_' + error.status;
                    reject([result, error.status]);
                });
        });
    }
    static async getEyonixURL(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post('https://eyonix-sql.fortrus.com/unity/rest/API/1.1/auth/url/', data)
                .then((response) => {
                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    let result =
                        "External System Links service error 'getEyonixURL()' " + error.status + '\n' + 'Response_Error_' + error.status;
                    reject([result, error.status]);
                });
        });
    }
}
